import React, { useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";

const QRCodeDisplay = ({ replicaLink }) => {
  const qrRef = useRef();
  const [copySuccess, setCopySuccess] = useState(false);

  const downloadQRCode = () => {
    const canvas = qrRef.current.querySelector("canvas");
    const url = canvas.toDataURL("image/png");
    const a = document.createElement("a");
    a.href = url;
    a.download = "qrcode.png";
    a.click();
  };

  const copyLink = async () => {
    try {
      if (navigator?.clipboard) {
        await navigator.clipboard.writeText(replicaLink);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = replicaLink;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
  
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error("Failed to copy link:", err);
    }
  };
  

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
      padding: "20px 0",
      fontFamily: "system-ui, -apple-system, sans-serif"
    },
    title: {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "16px",
      color: "#333"
    },
    qrContainer: {
      backgroundColor: "#FFF",
      padding: "16px",
      borderRadius:'6px',
      boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%  "
    },
    buttonContainer: {
      display: "flex",
      width: "67%",
      marginTop: "16px",
      gap: "8px"
    },
    button: {
      flex: 1,
      padding: "8px 0",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "14px",
      fontWeight: "500",
      color: "#FFF",
      gap: "6px"
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>My Referral Link</h2>
      <div style={styles.qrContainer}>
        <div ref={qrRef}>
          <QRCodeCanvas
            value={replicaLink}
            size={210}
            bgColor="#FFFFFF"
            fgColor="#000000"
            level="H"
            includeMargin={true}
            imageSettings={{
              src: "/images/planx.png",
              height: 56,
              width: 56,
              excavate: true,
            }}
          />
        </div>
        <div style={styles.buttonContainer}>
          <button
            onClick={copyLink}
            style={{
              ...styles.button,
              backgroundColor: copySuccess ? "#10B981" : "black"
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {copySuccess ? 
                <polyline points="20 6 9 17 4 12"></polyline> : 
                <><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></>
              }
            </svg>
            {copySuccess ? "Copied" : "Copy"}
          </button>
          <button
            onClick={downloadQRCode}
            style={{
              ...styles.button,
              backgroundColor: "#4B5563"
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default QRCodeDisplay;